const partnerNames = {
  crowdStrike: 'crowdstrike',
};

const partnerDisplayNames = {
  [partnerNames.crowdStrike]: 'CrowdStrike',
};

const statuses = {
  pending: 'PENDING_TRIAL',
  inTrial: 'IN_TRIAL',
  purchased: 'PURCHASED',
  suspended: 'SUSPENDED',
  cancelled: 'CANCELLED',
  terminated: 'TERMINATED',
};

export default {
  partnerDisplayNames,
  partnerNames,
  statuses,
};
